// SPDX-License-Identifier: AGPL-3.0-or-later

import type {ConduitMethod} from '@app/features/platform/types/TransportTypes';

export interface ConduitFailureDetail {
	method: ConduitMethod;
	path: string;
	status: number;
	body?: unknown;
	rawText?: string;
	responseHeaders?: Record<string, string>;
}

export class ConduitFailure extends Error {
	readonly method: ConduitMethod;
	readonly path: string;
	readonly status: number;
	readonly body: unknown;
	readonly rawText?: string;
	readonly responseHeaders: Record<string, string>;

	constructor(detail: ConduitFailureDetail) {
		super(`[${detail.status}] ${detail.method} ${redactNumericIds(detail.path)}`);
		this.name = 'ConduitFailure';
		this.method = detail.method;
		this.path = detail.path;
		this.status = detail.status;
		this.body = detail.body;
		this.rawText = detail.rawText;
		this.responseHeaders = detail.responseHeaders ?? {};
	}
}

function redactNumericIds(path: string): string {
	return path.replace(/\/(\d{5,})/g, () => `/:id`);
}
